var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createReducer, createActions } from 'reduxsauce';
/* ------------- Types and Action Creators ------------- */
var _b = createActions({
    setToastText: ['toastText']
}), Types = _b.Types, Creators = _b.Creators;
export var ToastTypes = Types;
export default Creators;
var INITIAL_STATE = {
    toastText: ''
};
// selector
export var valueSelector = function (state) {
    return state.toast;
};
/* ------------- Reducer ------------- */
export var reducer = createReducer(INITIAL_STATE, (_a = {},
    _a[Types.SET_TOAST_TEXT] = function (state, _a) {
        var toastText = _a.toastText;
        return (__assign(__assign({}, state), { toastText: toastText }));
    },
    _a));
